import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import { FaEye } from "react-icons/fa";
import { useSGPIBalanceList } from "./hooks/useSGPI";
import { useState } from "react";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import { COLORS } from "../../constants/colors";
import axiosInstance from "../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import { showToast } from "../../utils/toastUtils";

const SGPIBalance = () => {
  const [filtersState, setFiltersState] = useState({
    page: 1,
    limit: 10,
    search: "",
  });
      const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
      const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");
      const { startPolling, stopPolling } = useExcelPolling();

  const { data: sgpiBalanceList, isLoading: sgpiBalanceLoading } =
    useSGPIBalanceList({
      params: {
        start: filtersState?.page,
        length: filtersState?.limit,
        search: filtersState?.search,
        // employeeId: null,
        // sortColumn: "",
        // sortOrder: "",
      },
      enable: true,
    });

  console.log(
    "🚀 ~ SGPIBalance.tsx:27 ~ SGPIBalance ~ sgpiBalanceList:",
    sgpiBalanceList?.data?.recordsTotal
  );

  const handleEdit = () => {
    alert("hanele Edit");
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

       const downloadExcelGet = async () => {
  const appToken = localStorage.getItem("Apptoken") || "";
  const page= filtersState?.page
      const limit= filtersState?.limit
      const search= filtersState?.search
      const sortColumn= "SgpiId"
      const sortOrder= "DESC"


    const params = new URLSearchParams();

    // Append only if the value exists

    if (sortColumn) params.append("sortColumn", sortColumn);
    if (page) params.append("page", page.toString());
    if (limit) params.append("length", limit.toString());
    if (search) params.append("search", search);
    if (sortOrder) params.append("sortOrder", sortOrder);
     const queryString = new URLSearchParams(params).toString();
      try {
        setLoadingExcel(true);
        const response = await axiosInstance.get(
          `${API_ENDPOINTS.SGPI.GET_BALANCE_SGPI_LISTS_EXCEL}?${queryString}`
        );
        console.log("responseresponseresponse",response)
        const { success, fileDownloadId, intervalTime } =
          response?.data?.data|| null;
  
        if (success && fileDownloadId) {
          startPolling(fileDownloadId, intervalTime, {
            onStatusUpdate: (currentStatus: string) => {
              setExcelStatus(currentStatus);
            },
            onSuccess: (url: any) => {
              setLoadingExcel(false);
              setExcelStatus('Loading..');
              const a = document.createElement("a");
              a.href = url;
              a.download = "report.xlsx";
              a.click();
              showToast.success("The file is ready!");
            },
            onFailed: (msg: any) => showToast.error(msg || ""),
            onExpired: (msg: any) => showToast.error(msg || ""),
            onDeleted: (msg: any) => showToast.error(msg || ""),
          });
        }
      } catch (err: any) {
        showToast.error(err);
      }
    };
  return (
    <div className="p-2">
      <PageHeader title="SGPI Balance" buttons={[
         {
                             label: loadingExcel? excelStatus ? excelStatus.charAt(0).toUpperCase() + excelStatus.slice(1) +"..": "": "Excel",
                              onClick:downloadExcelGet,
                            color: loadingExcel ? COLORS.disable : COLORS.primary,
                                        disable: loadingExcel ? true : false,
                             },
      ]} />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "auto",
          marginTop: "2%",
        }}
      >
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <BasicDataTable
            search={true}
            dynamicHeightOnRowsPerPage={true}
            Title="SGPI Balance List"
            SearchPlaceholder="Search By Emp Name,SGPI Name"
            columns={dummyData(handleEdit)}
            data={sgpiBalanceList?.data?.data || []}
            headerContent={<></>}
            showSpinner={sgpiBalanceLoading}
            onChangePage={(pageNo: number) => {
              handlePagination(pageNo);
            }}
            onChangeRowsPerPage={(newPerPage: any, page: any) => {
              handleonChangeRowsPerPage(newPerPage, page);
            }}
            handleSearch={(val: any) => {
              handleSearch(val);
            }}
            paginationTotalRows={sgpiBalanceList?.data?.recordsTotal || 0}
          />
        </div>
      </div>
    </div>
  );
};
export default SGPIBalance;

const dummyData = (handleEdit: (row: any) => void) => [
  {
    name: "Employee Name",
    selector: (row: { AccountName: string }) => row?.AccountName || "-",
    minWidth: "200px",
    sortable: true,
    wrap: true,
  },
  {
    name: "Account Id",
    selector: (row: { SgpiAccountId: string }) =>
      row?.SgpiAccountId ?? "-",
    sortable: true,
    minWidth: "200px",
    wrap: true,
  },
  {
    name: "SGPI Name",
    selector: (row: { SgpiName: string }) => row?.SgpiName ?? "-",
    sortable: true,
    minWidth: "200px",
    wrap: true,
  },
  {
    name: "SGPI Code",
    selector: (row: { SgpiCode: string }) => row?.SgpiCode ?? "-",
    sortable: true,
    minWidth: "200px",
    wrap: true,
  },
  {
    name: "SGPI Type",
    selector: (row: { SgpiType: string }) => row?.SgpiType ?? "-",
    minWidth: "200px",
    sortable: true,
    wrap: true,
  },
  {
    name: "Use Start Date",
    selector: (row: { UseStartDate: string }) =>
      row.UseStartDate ? row.UseStartDate.split(".")[0] : "-",
    minWidth: "200px",
    sortable: true,
    wrap: true,
  },
  {
    name: "Use End Date",
    selector: (row: { UseEndDate: string }) =>
      row?.UseEndDate ? row?.UseEndDate.split(".")[0] : "-",
    minWidth: "200px",
    sortable: true,
    wrap: true,
  },
  {
    name: "Balance",
    selector: (row: { Balance: string }) => row?.Balance ?? "-",
    sortable: true,
    minWidth: "200px",
    wrap: true,
  },

  // {
  //   name: "Actions",
  //   cell: (row: any) => (
  //     <button
  //       onClick={() => handleEdit(row)}
  //       className="btn btn-primary"
  //       style={{
  //         borderRadius: "20px",
  //         padding: "5px",
  //         width: "80px",
  //         fontSize: "14px",
  //       }}
  //     >
  //       <FaEye size={14} style={{ fill: "#fff" }} />
  //       View
  //     </button>
  //   ),
  // },
];
